import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PickingListLabel, PurchaseOrderLineStockAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStockAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineStockAllocation,
  PurchaseOrderLineStockAllocation
> {
  constructor() {
    super('PurchaseOrderStockAllocation', $localize`Purchase Order Stock Allocation`);
  }

  allocate(purchaseOrderLineRequirementId: string, stockItemId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineRequirementId,
      stockItemId,
    });
  }

  updatePurchaseOrderStockAllocation(purchaseOrderStockAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderStockAllocation`, {
      purchaseOrderStockAllocationId,
      quantity,
    });
  }

  getPickingListLabel(purchaseOrderStockAllocationId: any, previousLocation: boolean): Observable<PickingListLabel> {
    return this.httpService.get<PickingListLabel>(
      `${this.apiUrl}/GetPickingListLabel?purchaseOrderStockAllocationId=${purchaseOrderStockAllocationId}&previousLocation=${previousLocation}`,
    );
  }

  getAllocations(purchaseOrderLineId: any): Observable<PurchaseOrderLineStockAllocation[]> {
    return this.httpService.get<PurchaseOrderLineStockAllocation[]>(
      `${this.apiUrl}/GetAllocations?purchaseOrderLineId=${purchaseOrderLineId}`,
    );
  }
}
